import {
  DataPointSetByNumberOptimisation,
  DataPointSetByNumberPrediction,
  DataPointSetStyle
} from 'features/charts/chart.models';
import { MmmModelChartOutputDto } from '../models/mmm-model-output';

export interface DataPointSetByNumberOptimsationResult {
  dataPointSet: DataPointSetByNumberOptimisation;
  spend: number;
  sourceCategoryName: string;
}

export const createDataPointSetByNumberPredictions = (
  chartOutput: MmmModelChartOutputDto | undefined
): DataPointSetByNumberPrediction[] => {
  const dataPointSets: DataPointSetByNumberPrediction[] =
    chartOutput?.chartPlots.map((value) => {
      const style = value.isPredicted
        ? DataPointSetStyle.DASHED
        : DataPointSetStyle.SOLID;

      const dataPointSetName = value.isPredicted
        ? `Predictive ${chartOutput.segmentValue}`
        : chartOutput.segmentValue;

      const parentDataPointSetName = value.isPredicted
        ? chartOutput.segmentValue
        : '';

      const dataPoint: DataPointSetByNumberPrediction = {
        xValue: value.spend,
        yValue: value.revenue,
        dataPointSetName,
        actualParentDataPointSetName: parentDataPointSetName,
        style
      };

      return dataPoint;
    }) ?? [];

  return dataPointSets;
};

export const createDataPointSetsByNumberOptimisation = (
  chartOutput: MmmModelChartOutputDto | undefined
): DataPointSetByNumberOptimisation[] => {
  const dataPointSets: DataPointSetByNumberOptimisation[] = [];

  if (!chartOutput) {
    return dataPointSets;
  }

  for (
    let spendIterable = 0;
    spendIterable < chartOutput.chartPlots.length;
    spendIterable++
  ) {
    const dataPointSet: DataPointSetByNumberOptimisation = {
      xValue: chartOutput.chartPlots[spendIterable].spend,
      yValue: chartOutput.chartPlots[spendIterable].revenue,
      dataPointSetName: chartOutput.segmentValue
    };

    dataPointSets.push(dataPointSet);
  }

  return dataPointSets;
};
